import React from 'react'
import './pdf-materials-section.less'

import { useTranslation } from 'react-i18next'
import { Button, Card } from 'antd'

const pdfMaterialsForPupilGrowingMap = [
  {
    title: 'manual.materials.1.title',
    assetLink: '/materials/ilk-qadam-bola-rivojlanish-xaritasi.pdf',
  },
]

const pdfMaterials = [
  {
    title: 'manual.materials.2.title',
    assetLink: '/materials/1.pdf',
  },
  {
    title: 'manual.materials.3.title',
    assetLink: '/materials/2.pdf',
  },
  {
    title: 'manual.materials.4.title',
    assetLink: '/materials/3.pdf',
  },
  {
    title: 'manual.materials.5.title',
    assetLink: '/materials/4.pdf',
  },
  {
    title: 'manual.materials.6.title',
    assetLink: '/materials/5.pdf',
  },
  {
    title: 'manual.materials.7.title',
    assetLink: '/materials/6.pdf',
  },
]

type Props = {
  onlyPupilGrowingMapBook?: boolean
}

export const PdfMaterialsSection = ({ onlyPupilGrowingMapBook }: Props) => {
  const { t } = useTranslation()
  const isMobile = window?.innerWidth < 768

  return (
    <div className="pdf-materials-section">
      {(onlyPupilGrowingMapBook
        ? pdfMaterialsForPupilGrowingMap
        : pdfMaterials
      ).map((material) => (
        <Card className="pdf-materials-section__card" key={material.title}>
          <div className="pdf-materials-section__item">
            <h6>{t(material.title)}</h6>
            {isMobile ? (
              <a href={material.assetLink} target="_blank" rel="noreferrer">
                <Button style={{ width: '100%' }} type="primary">
                  {t('general.download')}
                </Button>
              </a>
            ) : (
              <div>
                <a
                  href={material.assetLink}
                  download={`${t(material.title)}.pdf`}>
                  <Button
                    style={{ width: '100%', marginTop: '10px' }}
                    type="primary">
                    {t('general.download')}
                  </Button>
                </a>
                {/* <div className="pdf-materials-section__iframe">
                  <iframe src={material.assetLink}></iframe>
                </div> */}
                <a href={material.assetLink} target="_blank" rel="noreferrer">
                  <Button
                    style={{ width: '100%', marginTop: '10px' }}
                    type="primary">
                    {t('general.view')}
                  </Button>
                </a>
              </div>
            )}
          </div>
        </Card>
      ))}
    </div>
  )
}
